import {
  fetchSectionById,
  getAllsectionsForReview,
} from "../../services/axios/apiManager";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../Components/Header";
import { Swiper, SwiperSlide } from "swiper/react";
import { baseURL } from "../../services/axios/eps";
import LoadingSpinner from "../../Components/spinner";
import { handleErrors } from "../../services/dataManager";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Container, Row, Col, Button, Card, Badge } from "react-bootstrap";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

  /* ── Page wrapper ── */
  .rs-wrapper {
    min-height: 100vh;
    background: linear-gradient(160deg, #0d1117 0%, #161b22 50%, #0a0e14 100%);
    font-family: 'Inter', system-ui, sans-serif;
  }

  .rs-content {
    padding: 0 24px 64px;
    max-width: 1600px;
    margin: 0 auto;
  }

  /* ── Section heading ── */
  .rs-section-heading {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    padding: 28px 0 16px;
    margin: 0;
  }

  .rs-section-heading h1 {
    font-size: clamp(1.4rem, 3vw, 2rem);
    font-weight: 800;
    letter-spacing: -0.02em;
    background: linear-gradient(135deg, #ffffff 0%, #a8b5d8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin: 0;
    line-height: 1.2;
  }

  .rs-section-heading::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 48px;
    height: 3px;
    background: linear-gradient(90deg, #6366f1, #8b5cf6);
    border-radius: 999px;
  }

  .rs-heading-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 10px;
    background: rgba(99, 102, 241, 0.15);
    border: 1px solid rgba(99, 102, 241, 0.3);
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    color: #818cf8;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  /* ── Slider section ── */
  .rs-slider-section {
    padding: 4px 0 0;
    overflow: hidden;
  }

  /* ── Game card ── */
  .rs-game-card {
    border-radius: 14px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.07);
    cursor: pointer;
    transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1),
                box-shadow 0.3s ease,
                border-color 0.3s ease;
    backdrop-filter: blur(8px);
    display: flex;
    flex-direction: column;
  }

  .rs-game-card:hover {
    transform: translateY(-6px) scale(1.02);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5),
                0 0 0 1px rgba(99, 102, 241, 0.4),
                0 0 24px rgba(99, 102, 241, 0.15);
    border-color: rgba(99, 102, 241, 0.4);
  }

  .rs-game-card-img-wrapper {
    position: relative;
    overflow: hidden;
    aspect-ratio: 1 / 1;
    background: rgba(0,0,0,0.2);
  }

  .rs-game-card-img-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .rs-game-card:hover .rs-game-card-img-wrapper img {
    transform: scale(1.08);
  }

  .rs-game-card-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 50%);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .rs-game-card:hover .rs-game-card-overlay {
    opacity: 1;
  }

  .rs-game-card-play-btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
    background: rgba(99, 102, 241, 0.9);
    border: none;
    border-radius: 999px;
    padding: 5px 12px;
    font-size: 11px;
    font-weight: 700;
    color: #fff;
    letter-spacing: 0.04em;
    opacity: 0;
    transform: translateY(4px);
    transition: opacity 0.25s ease, transform 0.25s ease;
  }

  .rs-game-card:hover .rs-game-card-play-btn {
    opacity: 1;
    transform: translateY(0);
  }

  .rs-game-card-body {
    padding: 10px 12px 12px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
  }

  .rs-game-card-title {
    font-size: 13px;
    font-weight: 700;
    color: #f1f5f9;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    line-height: 1.3;
  }

  .rs-game-card-publisher {
    font-size: 11px;
    color: rgba(148, 163, 184, 0.8);
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* ── Swiper overrides ── */
  .rs-swiper .swiper-pagination-bullet {
    background: rgba(99, 102, 241, 0.5);
    opacity: 1;
    transition: background 0.2s, transform 0.2s;
  }
  .rs-swiper .swiper-pagination-bullet-active {
    background: #6366f1;
    transform: scale(1.3);
  }

  /* ── Tournament card ── */
  .rs-tournament-card {
    position: relative;
    border-radius: 24px;
    overflow: hidden;
    background: linear-gradient(135deg, rgba(20,26,40,0.95) 0%, rgba(14,18,28,0.95) 100%);
    border: 1px solid rgba(99, 102, 241, 0.2);
    backdrop-filter: blur(20px);
    padding: 48px 40px;
    margin-bottom: 32px;
    box-shadow: 0 32px 64px rgba(0, 0, 0, 0.5),
                0 0 0 1px rgba(99, 102, 241, 0.1);
  }

  .rs-tournament-card::before {
    content: '';
    position: absolute;
    top: -80px;
    right: -80px;
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, rgba(99, 102, 241, 0.12) 0%, transparent 70%);
    pointer-events: none;
  }

  .rs-tournament-card::after {
    content: '';
    position: absolute;
    bottom: -60px;
    left: -60px;
    width: 250px;
    height: 250px;
    background: radial-gradient(circle, rgba(139, 92, 246, 0.08) 0%, transparent 70%);
    pointer-events: none;
  }

  .rs-live-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 14px;
    background: linear-gradient(135deg, #dc2626, #ef4444);
    border-radius: 999px;
    font-size: 11px;
    font-weight: 800;
    color: #fff;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.4);
    margin-bottom: 20px;
  }

  .rs-live-dot {
    width: 7px;
    height: 7px;
    background: #fff;
    border-radius: 50%;
    animation: rs-pulse 1.4s ease-in-out infinite;
  }

  @keyframes rs-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.4; transform: scale(0.75); }
  }

  .rs-tournament-title {
    font-size: clamp(1.6rem, 4vw, 2.6rem);
    font-weight: 900;
    color: #fff;
    letter-spacing: -0.03em;
    line-height: 1.1;
    margin: 0 0 16px;
    background: linear-gradient(135deg, #ffffff 0%, #c7d2fe 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .rs-tournament-desc {
    font-size: 1rem;
    color: rgba(165, 180, 252, 0.85);
    line-height: 1.65;
    margin: 0 0 32px;
    max-width: 480px;
  }

  .rs-btn-primary {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    border: none;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    box-shadow: 0 8px 24px rgba(99, 102, 241, 0.35);
    text-decoration: none;
  }

  .rs-btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(99, 102, 241, 0.5);
    color: #fff;
  }

  .rs-btn-secondary {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(255,255,255,0.85);
    cursor: pointer;
    transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease;
    backdrop-filter: blur(8px);
    text-decoration: none;
  }

  .rs-btn-secondary:hover {
    transform: translateY(-2px);
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.3);
    color: #fff;
  }

  /* ── Tournament game images ── */
  .rs-game-img-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .rs-game-img-item {
    position: relative;
    border-radius: 18px;
    overflow: hidden;
    border: 2px solid rgba(99, 102, 241, 0.2);
    box-shadow: 0 12px 32px rgba(0,0,0,0.4);
    transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1),
                box-shadow 0.35s ease,
                border-color 0.35s ease;
    cursor: pointer;
    flex-shrink: 0;
  }

  .rs-game-img-item:hover {
    transform: scale(1.06) rotate(-1deg);
    border-color: rgba(99, 102, 241, 0.6);
    box-shadow: 0 20px 48px rgba(0,0,0,0.6), 0 0 0 1px rgba(99, 102, 241, 0.4);
    z-index: 2;
  }

  .rs-game-img-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .rs-game-img-label {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 8px 10px;
    background: linear-gradient(to top, rgba(0,0,0,0.85) 0%, transparent 100%);
    font-size: 11px;
    font-weight: 700;
    color: rgba(255,255,255,0.9);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* ── Loading state ── */
  .rs-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 120px 0;
    color: rgba(148, 163, 184, 0.6);
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.04em;
  }

  /* ── Responsive ── */
  @media (max-width: 768px) {
    .rs-tournament-card {
      padding: 28px 20px;
    }
    .rs-content {
      padding: 0 12px 48px;
    }
  }
`;

const ReviewSections = ({ navigate }) => {
  const { secId } = useParams();
  const [sectionData, setSectionData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getdata = async () => {
      let res;
      if (secId) {
        res = await fetchSectionById(secId);
        if (res?.data?.success && res.data?.data) {
          setSectionData([res.data.data]);
        } else {
          handleErrors(res, navigate, "Review Home Page: ");
        }
      } else {
        res = await getAllsectionsForReview();
        if (res?.data?.success && res?.data?.data) {
          setSectionData(res.data.data);
        } else {
          handleErrors(res, navigate, "Review Home Page: ");
        }
      }
      setLoading(false);
    };

    getdata();
  }, [secId]);

  // // // Slider section
  const renderSlider = (section, randomSpeed, randomDelay) => (
    <section className="rs-slider-section" key={section.id}>
      <div className="rs-section-heading">
        <span className="rs-heading-pill">Featured</span>
        <h1>{section.heading}</h1>
      </div>

      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={16}
        slidesPerView={"auto"}
        loop={true}
        autoplay={{ delay: randomDelay, disableOnInteraction: false }}
        speed={randomSpeed}
        pagination={{ clickable: true }}
        className="rs-swiper !pb-10"
        breakpoints={{
          320: { spaceBetween: 10, slidesPerView: 2 },
          640: { spaceBetween: 14, slidesPerView: 3 },
          1024: { spaceBetween: 16, slidesPerView: 4 },
          1280: { spaceBetween: 16, slidesPerView: 5 },
          1536: { spaceBetween: 16, slidesPerView: 6 },
        }}
      >
        {section?.games?.map((game) => (
          <SwiperSlide key={game.id}>
            <div className="rs-game-card">
              <div className="rs-game-card-img-wrapper">
                <img
                  crossOrigin="anonymous"
                  src={`${baseURL}/uploads/file/${game?.icon}`}
                  alt={game.title || "Game icon"}
                />
                <div className="rs-game-card-overlay" />
                <button className="rs-game-card-play-btn">▶ Play</button>
              </div>
              <div className="rs-game-card-body">
                <p className="rs-game-card-title">{game.title}</p>
                <p className="rs-game-card-publisher">
                  {game?.published_by ? `By ${game.published_by}` : ""}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
  const renderCategorySlider = (section, randomSpeed, randomDelay) => (
    <section className="rs-slider-section" key={section.id}>
      <div className="rs-section-heading">
        <span className="rs-heading-pill">Featured</span>
        <h1>{section.heading}</h1>
      </div>

      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={16}
        slidesPerView={"auto"}
        loop={true}
        autoplay={{ delay: randomDelay, disableOnInteraction: false }}
        speed={randomSpeed}
        pagination={{ clickable: true }}
        className="rs-swiper !pb-10"
        breakpoints={{
          320: { spaceBetween: 10, slidesPerView: 2 },
          640: { spaceBetween: 14, slidesPerView: 3 },
          1024: { spaceBetween: 16, slidesPerView: 4 },
          1280: { spaceBetween: 16, slidesPerView: 5 },
          1536: { spaceBetween: 16, slidesPerView: 6 },
        }}
      >
        {section?.games?.map((game) => (
          <SwiperSlide key={game.id}>
            <div className="rs-game-card">
              <div className="rs-game-card-img-wrapper">
                <img
                  crossOrigin="anonymous"
                  src={`${baseURL}/uploads/file/${game?.icon}`}
                  alt={game.title || "Game icon"}
                />
                <div className="rs-game-card-overlay" />
                <button className="rs-game-card-play-btn">▶ Play</button>
              </div>
              <div className="rs-game-card-body">
                <p className="rs-game-card-title">{game.title}</p>
                <p className="rs-game-card-publisher">
                  {game?.published_by ? `By ${game.published_by}` : ""}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );

  // // // Tournament section
  const renderTournament = (section) => {
    const games = section.games ?? [];
    const gameCount = games.length;

    const getImgSize = (count) => {
      if (count === 1) return { width: 400, height: 400 };
      if (count === 2) return { width: 260, height: 260 };
      return { width: 220, height: 220 };
    };

    const { width, height } = getImgSize(gameCount);

    return (
      <div key={section.id} style={{ marginBottom: 8 }}>
        <Container className="rs-tournament-card">
          <Row className="align-items-center gy-5">
            <Col lg={6}>
              <div className="rs-live-badge">
                <span className="rs-live-dot" />
                Live Now
              </div>

              <h2 className="rs-tournament-title">{section.heading}</h2>

              {(section.details || section.subheading) && (
                <p className="rs-tournament-desc">
                  {section.details || section.subheading}
                </p>
              )}

              <div className="d-flex gap-3 flex-wrap">
                <button className="rs-btn-primary">🏆 Join Tournament</button>
                <button className="rs-btn-secondary">📺 Watch Stream</button>
              </div>
            </Col>

            <Col lg={6}>
              <div
                className="rs-game-img-grid"
                style={
                  gameCount === 1
                    ? { justifyContent: "center" }
                    : { justifyContent: "center" }
                }
              >
                {games.slice(0, 4).map((game) => (
                  <div
                    key={game.id}
                    className="rs-game-img-item"
                    style={{ width, height }}
                  >
                    <img
                      src={`${baseURL}/uploads/file/${game?.icon}`}
                      alt={game.title}
                    />
                    <div className="rs-game-img-label">{game.title}</div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  };

  const renderSection = (section) => {
    const minDelay = 1800;
    const maxDelay = 3000;
    const minSpeed = 1000;
    const maxSpeed = 2000;
    const randomDelay =
      Math.floor(Math.random() * (maxDelay - minDelay + 1)) + minDelay;
    const randomSpeed =
      Math.floor(Math.random() * (maxSpeed - minSpeed + 1)) + minSpeed;

    switch (section.section_type) {
      case "slider":
        return renderSlider(section, randomSpeed, randomDelay);
      case "tournament":
        return renderTournament(section);
      case "category_wise":
        return renderCategorySlider(section, randomSpeed, randomDelay);
      default:
        return null;
    }
  };

  return (
    <div className="rs-wrapper">
      <style>{styles}</style>
      <Header />
      <button
        onClick={() => navigate("/home-page")}
        style={{
          // position: "absolute",
          top: "30px",
          left: "30px",
          zIndex: 10,
          padding: "10px 20px",
          backgroundColor: "rgba(20, 28, 48, 0.85)",
          color: "#fff",
          border: "1px solid #ffffff30",
          borderRadius: "4px",
          cursor: "pointer",
          fontWeight: "600",
          fontFamily: "Arial, sans-serif",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          transition: "background-color 0.2s",
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.backgroundColor = "rgba(20, 28, 48, 1)")
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.backgroundColor = "rgba(20, 28, 48, 0.85)")
        }
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        Back to sections
      </button>

      {loading ? (
        <div className="rs-loading">
          <LoadingSpinner size="lg" />
          <span>Loading sections…</span>
        </div>
      ) : (
        <div>
          <div className="rs-content">
            {sectionData.map((sec) => renderSection(sec))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewSections;

// slider, game_list, tournament, category_wise, promotion, custom_html
